import { createSlice } from '@reduxjs/toolkit';

const getInitialPage = () => {
  try {
    return localStorage.getItem('currentPage') || 'dashboard';
  } catch {
    return 'dashboard';
  }
};

const initialState = {
  currentPage: getInitialPage(),
  sidebarOpen: true,
  darkMode: false,
  loading: false,
  notifications: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
      try {
        localStorage.setItem('currentPage', action.payload);
      } catch {
        // Ignore localStorage errors
      }
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now(),
        ...action.payload,
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
  },
});

export const {
  setCurrentPage,
  toggleSidebar,
  setSidebarOpen,
  toggleDarkMode,
  setLoading,
  addNotification,
  removeNotification,
} = uiSlice.actions;

export default uiSlice.reducer;